import React, { Component } from 'react';
import { pushEvent } from '../../utils/analytics.js';
import { triggerIntroReveal } from '../App';


import Title from '../../components/navigation/Title'

// import AnimatedWrapper from '../AnimatedWrapper'
import Section from '../../containers/SectionWrapper'
import Hero from '../../components/hero/Hero.js'
import Brands from '../../components/about/Brands'
import Stars from '../../components/carousel/Animations/Stars'

// import Image from '../../components/pageContent/Image'
import Media from '../../components/pageContent/Media'

import Watermark from '../../components/pageContent/Watermark'
import Loading from '../../components/pageContent/Loading'
import List from '../../components/pageContent/List'
import Sections from '../../components/pageContent/Sections'
import Quote from '../../components/pageContent/Quote'
import { getUrl } from '../../utils/services.js'
// import Button from '../../components/pageContent/Button.js'

// import Blackout from '../../components/wrappers/Blackout'
import Footer from '../../components/footer/Footer.js'


class Page extends Component {

	constructor(props) {

		super(props)

		this.state = {
			isLoading: false,
			isLoaded: false,
			data: {},
			hero: {}
		}

		this.getData = this.getData.bind(this)

	}

	getData() {

		this.setState({
			isLoading: true
		})

		getUrl(`/api/about`).then((data) => {

			// console.log(data)

			this.setState({
				data: data.about.fields,
				hero: data.hero.fields,
				isLoading: false,
				isLoaded: true
			}, () => {
				if (this.props.onPageReady) {
					this.props.onPageReady();
				}
				triggerIntroReveal();
			})

		})

	}

	componentDidMount() {
		pushEvent();
		this.getData()
	}


	render() {

		const { data, hero, isLoaded, isLoading } = this.state
		const { viewport, title } = this.props

		return (
			<div>

				<Title text={title} />

				{isLoading && <Loading />}

				{isLoaded &&

					<div>

						<Watermark txt={data.watermark} viewport={viewport} />

						<Hero title={hero.title} subtitle={hero.subtitle} color="#fff" theme="light" viewport={viewport} isCentered={true}
							
							background={
								<Stars viewport={viewport} isActive={true} />
							}
							showScroll={true}
						/>


						{/* <div className="ptmd pbmd xs-ptsm xs-pbsm">
							<div className="grid ">

								<div className="unit one-third xs-p0">

									<Section pullUp={true}>

										<List title="Skills" items={data.skills} className="bg-yellow ptmd pbmd xs-ptsm xs-pbsm" />

									</Section>

								</div>
								<div className="unit one-third xs-p0">

									<div className="ptsm xs-pt0">

										<Section pullUp={true}>

											<List title="Experience" items={data.experience} className="bg-salmon ptmd pbmd xs-ptsm xs-pbsm" />

										</Section>

									</div>

								</div>

								<div className="unit one-third xs-p0">

									<div className="ptmd xs-pt0">

										<Section pullUp={true}>

											<List title="This" items={data.features} className="bg-light-grey ptmd pbmd xs-ptsm xs-pbsm" />

										</Section>

									</div>

								</div>

							</div>
						</div> */}


						{/* {data.hero &&

							<div className="ptlg pblg xs-ptsm xs-pbsm">

								<div className="grid">

									<div className="unit whole xs-p0">

										<Media
											data={data.hero}
											showBar={true}
										/>

									</div>

								</div>

							</div>

						} */}

						{data.quote &&
							<Quote text={data.quote} />
						}

						{data.brands &&
							<Brands brands={data.brands} />
						}

						{data.sections &&
							<Sections sections={data.sections} />
						}

						
						{/* <Blackout>


							<div className="ptlg pblg">

								<div className="grid">

									<div className="unit one-third	">

										<h1>
											A blackout.
										</h1>

										<p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima impedit quaerat amet ut, recusandae eius veniam laborum laudantium ea adipisci quod necessitatibus dolores, ullam facere magni dolore possimus sequi? Mollitia!</p>

										<p>
											<Button to="/" className="poke">Look</Button>
										</p>

									</div>

								</div>

							</div>

						</Blackout> */}


						<Footer viewport={viewport} />


						


					</div>

				}



			</div>
		);
	}
}

// const Wrapper = AnimatedWrapper(Page);
export default Page;